'use strict'

class LangSwitcher {
    static getLangLink(langId) {
        // Проверяем, совпадает ли языковой ID сайта с текущим
        if (!BX.message('SITE_DIR') || langId === BX.message('SITE_DIR')) {
            // Возвращаем url адрес страницы без изменений
            return false;
        } else {
            // Получаем константу BX.message('SITE_DIR') для языковой ID сайта
            let siteDir
            if (langId === 'ru') {
                siteDir = '/'
            } else {
                siteDir = '/' + langId + '/'
            }
            // Заменяем в url адресе страницы текущую константу BX.message('SITE_DIR') на новую
            let newUrl = location.pathname.replace(new RegExp('^' + BX.message('SITE_DIR').replace('/', '\\/')), siteDir) + location.search + location.hash
            let currentUrl = location.pathname + location.search + location.hash
            if (currentUrl !== newUrl) {
                location.href = newUrl
            } else {
                return false
            }
        }
    }
}
window.TimeCity = window.TimeCity || {};
window.TimeCity.LangSwitcher = LangSwitcher;